import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";

interface ImageSliderProps {
  items: { title: string; description: string; style?: any }[];
  bottom?: string;
  left?: string;
  width?: string;
  imageWidth?: string;
  gap?: string;
}

const ImageSlider: React.FC<ImageSliderProps> = ({ items, bottom = "4%", left = "0", width = "100%", imageWidth = "25%", gap = "2%" }) => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);
  const currentPage = useSelector((state: { appReducer: { currentPage: number } }) => state.appReducer.currentPage);

  useEffect(() => {
    setIsVisible(false);
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);

    return () => clearTimeout(timer);
  }, [currentPage]);

  return (
    <div
      ref={containerRef}
      style={{
        position: "absolute",
        bottom,
        left,
        width,
        height: "auto",
        pointerEvents: "none",
        zIndex: 10,
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: gap,
        overflow: "hidden",
      }}
    >
      {items.map((item, i) => (
        <div
          key={i}
          style={{
            width: imageWidth,
            opacity: isVisible ? 1 : 0,
            transform: `translateX(${isVisible ? 0 : "-100%"})`,
            transition: `opacity 0.7s ease-out, transform 0.7s ease-out`,
            transitionDelay: `${i * 0.3}s`,
            marginRight: i < items.length - 1 ? gap : 0,
            ...(item.style ? item.style : {}),
          }}
        >
          <div
            style={{
              color: "#FE4F02",
              fontFamily: '"Myriad Pro"',
              fontSize: "var(--width-55)",
              fontStyle: "normal",
              fontWeight: 700,
              lineHeight: "110%",
            }}
          >
            {item.title}
          </div>
          <div
            style={{
              color: "#FFF",
              fontFamily: '"Myriad Pro"',
              fontSize: "var(--width-24)",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "140%",
            }}
          >
            {item.description}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ImageSlider;
